export var FetchStatus;
(function (FetchStatus) {
    FetchStatus["PENDING"] = "PENDING";
    FetchStatus["FULFILLED"] = "FULFILLED";
    FetchStatus["REJECTED"] = "REJECTED";
    FetchStatus["INVALID_STATUS"] = "INVALID_STATUS";
})(FetchStatus || (FetchStatus = {}));
export var INITIAL_FETCH_STATUS = 'INITIAL';
export var FetchStatusInitialStatus;
(function (FetchStatusInitialStatus) {
    FetchStatusInitialStatus["INITIAL_FETCH_STATUS"] = "INITIAL";
})(FetchStatusInitialStatus || (FetchStatusInitialStatus = {}));
